import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Errored from '../core/Errored';
import EventBar from '../core/EventBar';
import EventProvider from '../core/providers/EventProvider';
import ProjectProvider from '../core/providers/ProjectProvider';
import { processHashLocation } from '../core/utils/utils';
import GS from '../grafsync/grafsync';
import OntologyData from './OntologyData';
import OntologyEditorContainer from './OntologyEditorContainer';

class OntologyManager extends Component {

  constructor(props) {
    super(props);
    const initState = OntologyManager.computeState(props);
    this.state = Object.assign(
      {
        viewValue: 1
      }, initState);
  }

  static getDerivedStateFromProps(props) {
    return OntologyManager.computeState(props);
  }

  static computeState(props) {
    const paramsMap = processHashLocation(props.location);
    const ontologyIRI = paramsMap.get("ontology");
    let isErrored = !ontologyIRI || ontologyIRI === "";
    try {
      const projectData = GS.data(props.id, props.graph);
      if (!projectData.hasComponent.includes(ontologyIRI)) isErrored = true;
    }
    catch (e) {
      isErrored = true;
    }
    return {
      ontologyIRI,
      isErrored
    };
  }

  toggleOntologyDetail = (value) => this.setState({ viewValue: value });

  render() {

    const { viewValue, ontologyIRI, isErrored } = this.state;
    const { project, graph, entitlements } = this.props;


    if (isErrored) return <Errored data={{ message: "An invalid ontology IRI has been supplied" }} />;

    return (
      <ProjectProvider value={this.props.data}>
        <EventProvider>
          <EventBar />
        </EventProvider>
        {
          viewValue === 0 ?
            <OntologyData
              projectIRI={project}
              graph={graph}
              entitlements={entitlements}
              toggleOntologyDetail={this.toggleOntologyDetail}
              id={ontologyIRI} />
            :
            <OntologyEditorContainer
              key={ontologyIRI}
              project={project}
              location={this.props.location}
              toggleOntologyDetail={this.toggleOntologyDetail}
              graph={graph}
              id={ontologyIRI}
              defaultLang={this.props.data.defaultLang} />
        }
      </ProjectProvider>
    );
  }
}

OntologyManager.propTypes = {
  entitlements: PropTypes.array,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired
};

export default withRouter(OntologyManager);
